import React, { useState, useEffect } from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import styles from './Search.module.scss';
import useDebouncedValue from '../../../hooks/useDebouncedValue';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

function Search(props) {
  const { search, searchQuery, setTooltip } = props;
  const title = props.title || 'Search product';
  const placeholder = props.placeholder || 'Title, sku, description';

  const [value, setValue] = useState(searchQuery);
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const debouncedValue = useDebouncedValue(value, 300);

  useEffect(() => {
    if (isInitialLoad) {
      setIsInitialLoad(false);
      return;
    }

    search(debouncedValue);
    // eslint-disable-next-line
  }, [search, debouncedValue]);

  const getOverlayTrigger = ({ placement, content }) => {
    return (
      <OverlayTrigger
        key={placement}
        placement={placement}
        overlay={
          content ? (
            <Tooltip id={`tooltip-${placement}`}>
              <h6>{content}</h6>
            </Tooltip>
          ) : undefined
        }
      >
        <input type="text" value={value} placeholder={placeholder} onChange={(e) => setValue(e.target.value)} />
      </OverlayTrigger>
    );
  };
  const setSearchInput = setTooltip ? (
    getOverlayTrigger(setTooltip)
  ) : (
    <input type="text" value={value} placeholder={placeholder} onChange={(e) => setValue(e.target.value)} />
  );

  return (
    <div className={styles.container}>
      <div className={styles.title}>{title}</div>
      <div className={cn('search', styles.search)}>
        {setSearchInput}
        <div className="ic-search" />
      </div>
    </div>
  );
}

export default Search;

Search.propTypes = {
  search: PropTypes.func.isRequired,
  searchQuery: PropTypes.string.isRequired,
};
